<template>
  <v-dialog v-model="editDialog" persistent max-width="600px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t(`Edit Cashier Transaction's Information`) }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 pa-2>
              <p>{{ `${$t('Currency Type')} *` }}</p>
              <v-radio-group
                v-model="viewInfo.currency_type"
                name="currency_type"
                v-validate="'required'"
                row
                readonly
                @change="newBalance"
              >
                <v-radio :label="$t('USD')" value="USD" />
                <v-radio :label="$t('IQD')" value="IQD" />
              </v-radio-group>
            </v-flex>

            <v-flex xs6 pa-2>
              <v-text-field
                :value="viewInfo.begin"
                :label="`${$t('Begin Balance')} *`"
                name="begin"
                box
                hide-details
                readonly
                background-color="white"
                :error="errors.has('begin')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs6 pa-2>
              <v-text-field
                :value="viewInfo.balance"
                :label="`${$t('Current Balance')} *`"
                name="balance"
                box
                hide-details
                readonly
                background-color="white"
                :error="errors.has('balance')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs12 pa-2>
              <p>{{ `${$t('Transaction Type')} *` }}</p>
              <v-radio-group
                v-model="viewInfo.transaction_type"
                name="transaction_type"
                v-validate="'required'"
                row
                @change="newBalance"
              >
                <v-radio :label="$t('To Cash')" value="To Cash" color="blue" />
                <v-radio :label="$t('To Cashier')" value="To Cashier" color="blue" />
              </v-radio-group>
            </v-flex>

            <v-flex xs6 pa-2>
              <v-text-field
                v-model="viewInfo.amount"
                :label="`${$t('Amount')} *`"
                name="amount"
                box
                hide-details
                background-color="white"
                :error="errors.has('amount')"
                v-validate="'required|decimal|min_value:0'"
                @input="newBalance"
              />
            </v-flex>

            <v-flex xs6 pa-2>
              <v-text-field
                v-model="viewInfo.balance_after_transaction"
                :label="`${$t('Balance After Transaction')} *`"
                name="balance_after_transaction"
                box
                hide-details
                readonly
                background-color="white"
                :error="errors.has('balance_after_transaction')"
                v-validate="'required'"
              />
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      dateMenu: false,
      btnUpdateLoading: false,
      transaction_date: ''
    }
  },

  computed: {
    ...mapGetters({
      viewInfo: 'cashierTransactions/getTransactionInfo',
      fullStaffList: 'staff/getFullStaffsList'
    })
  },

  mounted() {
    this.setFullStaffList()
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.transaction_date = this.viewInfo.transaction_date
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateCashierInfo: 'cashierTransactions/updateTransactionInfo',
      setFullStaffList: 'staff/setFullStaffsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    newBalance() {
      const amount = this.viewInfo.transaction_type === 'To Cash' ? -this.viewInfo.amount : this.viewInfo.amount
      this.viewInfo.balance_after_transaction = Number(amount) + this.viewInfo.balance
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)
          formData.append('main_cashier_id_fk', this.viewInfo.main_cashier_id_fk)

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.viewInfo.cashier_transaction_id, formData }

          this.updateCashierInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped></style>
